import QuickApprovalWorkflow from './QuickApprovalWorkflow';
import DirectLink from './DirectLink';
import NewSQLUser from './NewSQLUser';
import NewADUser from './NewADUser';
import WorkflowTask from './WorkflowTask';
import NewDocument from './NewDocument';
import Import from './Import';
import Rename from './Rename';

const Modals = {
  QUICK_APPROVAL_WORKFLOW: QuickApprovalWorkflow,
  DIRECT_LINK: DirectLink,
  NEW_SQL_USER: NewSQLUser,
  NEW_AD_USER: NewADUser,
  WORKFLOW_TASK: WorkflowTask,
  NEW_DOCUMENT: NewDocument,
  IMPORT: Import,
  RENAME: Rename
}

export default Modals;
